/* global Blockly */
import React from 'react';
import util from "../../../../../../../utils/es5Utils";
import { flipSwitchIcon } from "./index";


function defineBlock(context) {
    return {
        init: function () {
            let selectFlipSwitchDropdown = new Blockly.FieldWidgetsDropdown(context, 'flipswitch', undefined, '- select -');

            this.appendDummyInput('WIDGET')
                .appendField('set')
                .appendField(new Blockly.FieldImage(flipSwitchIcon, 30, 30, 'flipSwitch icon', null), 'flipSwitchIcon')
                .appendField(selectFlipSwitchDropdown, 'ID');

            this.appendValueInput('VALUE')
                .appendField('to')
                .setCheck("Boolean");

            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Set the value of a switch.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#switches`);
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let flipSwitchId = block.getFieldValue('ID');
            let value = "(" + Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_NONE) + ") ? 1 : 0";
            var code = "Snap.widgets.switch.setValue('" + flipSwitchId + "'," + value + ");\n";
            return code;
        }
    }
}

const SetFlipSwitchValue = function (props) {
    const name = 'snap_set_flipswitch_value';
    SetFlipSwitchValue.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return util.widgetsOfType(props.context, "flipswitch").length ? 
    <block type={name}>
        <value name="VALUE">
            <shadow type="logic_boolean"></shadow>
        </value>
    </block> : 
    null;
}

export default SetFlipSwitchValue;
